import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaPesquisaCivilRequest } from './types';

// ACTIONS
import {
	consultaPesquisaCivilSuccess,
	consultaPesquisaCivilFailure,
} from './actions';
import { consultaPesquisaCidadaoSuccess } from '../consultaPesquisaCidadao/actions';

function* consultaPesquisaCivilRequest(request: ReducerAction) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultaPesquisaCivilRequest } = request;
	const { usuario, ...params } = payload;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'civil',
		params,
		undefined,
		undefined,
		undefined,
		usuario,
		undefined,
	);

	if (response.status === 200) {
		yield put(consultaPesquisaCivilSuccess(response.data.pessoa));
		yield put(consultaPesquisaCidadaoSuccess(response.data));
	} else if (response.error) {
		yield put(consultaPesquisaCivilFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PESQUISA_CIVIL_REQUEST,
		consultaPesquisaCivilRequest,
	),
]);
